<template>
  <div>
    <a href="#" v-for="exampleImage in exampleImages" v-on:click.prevent="$emit('picked', exampleImage)" v-bind:class="['example-image-button', `example-image-button-${theme}`]" ondragstart="return false;">
      <img v-bind:src="exampleImage.thumbnail_url" alt="Example image" class="img-fluid rounded example-image">
    </a>
  </div>
</template>

<script>

export default {
  mounted() {
    this.setExampleImages();
  },
  props: {
    theme: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      exampleImages: []
    };
  },
  methods: {
    setExampleImages() {
      var base = "https://static.remove.bg/uploader-samples/";

      var available = [
        [
          {url: `${base}person/1.jpg`, thumbnail_url: `${base}person/1_thumbnail.jpg`},
          {url: `${base}person/2.jpg`, thumbnail_url: `${base}person/2_thumbnail.jpg`},
          {url: `${base}person/3.jpg`, thumbnail_url: `${base}person/3_thumbnail.jpg`},
          {url: `${base}person/4.jpg`, thumbnail_url: `${base}person/4_thumbnail.jpg`},
        ],
        [
          {url: `${base}animal/1.jpg`, thumbnail_url: `${base}animal/1_thumbnail.jpg`},
          {url: `${base}animal/2.jpg`, thumbnail_url: `${base}animal/2_thumbnail.jpg`},
          {url: `${base}animal/3.jpg`, thumbnail_url: `${base}animal/3_thumbnail.jpg`},
          {url: `${base}animal/4.jpg`, thumbnail_url: `${base}animal/4_thumbnail.jpg`},
          {url: `${base}animal/5.jpg`, thumbnail_url: `${base}animal/5_thumbnail.jpg`},
        ],
        [
          {url: `${base}product/1.jpg`, thumbnail_url: `${base}product/1_thumbnail.jpg`},
          {url: `${base}product/2.jpg`, thumbnail_url: `${base}product/2_thumbnail.jpg`},
          {url: `${base}product/3.jpg`, thumbnail_url: `${base}product/3_thumbnail.jpg`},
          {url: `${base}product/4.jpg`, thumbnail_url: `${base}product/4_thumbnail.jpg`},
          {url: `${base}product/5.jpg`, thumbnail_url: `${base}product/5_thumbnail.jpg`},
        ],
        [
          {url: `${base}car/1.jpg`, thumbnail_url: `${base}car/1_thumbnail.jpg`},
          {url: `${base}car/2.jpg`, thumbnail_url: `${base}car/2_thumbnail.jpg`},
          {url: `${base}car/3.jpg`, thumbnail_url: `${base}car/3_thumbnail.jpg`},
          {url: `${base}car/4.jpg`, thumbnail_url: `${base}car/4_thumbnail.jpg`},
        ],
      ];

      for(var i = 0; i < available.length; i++) {
        var category = available[i];
        var n = Math.floor(Math.random() * category.length);
        this.exampleImages.push(category[n]);
      }
    },
  }
}
</script>

<style scoped>

.example-image-button {
  display: inline-block;
  opacity: 1.0;
}
.example-image-button:hover {
  opacity: 0.8;
}

/* DEFAULT */
.example-image-button-default {
  margin: 0 5px;
}
.example-image-button-default .example-image {
  max-width: 60px;
}

/* SMALL */
.example-image-button-small {
  margin: 0 2px;
}
.example-image-button-small .example-image {
  max-width: 40px;
}
</style>
